<template>
      <div class="filterRow d-flex  mb-2 p-3 bg-white mobile_side_dc">
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Start Time</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="StartTime" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="From Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">End Time</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="EndTime" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="To Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Select RTO Number</label>
                <!-- <dropdownlist style="width: 190px" :data-items="getVehicles" :text-field="'rtoNumber'"
                    :data-item-key="'id'" v-model="searchingVehicleRtoNumber">
                </dropdownlist> -->
                <dropdownlist :data-items="getFilteredVehicles" :default-item="defaultTeam" style="width: 190px" :data-item-key="'id'"
                    :filterable="true" @change="changeVehicle" :text-field="'rtoNumber'" v-model="RTONumber" :name="'imeiVal'"
                    :required="true" >

                </dropdownlist>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Duration (minutes)</label>
                <!-- <dropdownlist style="width: 190px" :data-items="getVehicles" :text-field="'rtoNumber'"
                    :data-item-key="'id'" v-model="searchingVehicleRtoNumber">
                </dropdownlist> -->
                 <k-input type="number" min="1" class="mr-1 mb-1" v-model="Duration"/>
            </div>
        </div>
          <div class="d-flex mr-3">
        <div title="Summary Report" v-if="isSummeryReportExist" class="rf-col mt-1 ml-2 mt-4" style="width: 79px;">
            <div class="d-flex">
              <label class="mt-2 mr-1">Summary</label>
                <div class="checkbox ml-0 mr-2 mt-2">
                <input type="checkbox" class="{'active-track':track=='all'}" @change="$emit('onChangeSummaryRec',$event)"/>
                </div>
            </div>
            </div>
         </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <div class="p-2"></div>
                <kendo-button title="Search" :style="{ marginTop: '6px' }" class="k-primary ml-1"
                    @click="onChange">Search</kendo-button>
            </div>
        </div>
    </div>
</template>

<script>
import { notifyWarn } from '@/utils/notification-helper';

import { formatISO,convertMinutes } from '@/utils/date-helpers'
import { createNamespacedHelpers } from "vuex";
const {mapGetters } = createNamespacedHelpers("reports");
export default {
  data() {
    return {
      RosterType: "General",
      StartTime:new Date(new Date().setHours(0,0,0,0)),
      EndTime:new Date(new Date().setHours(23,59,0,0)),
      RTONumber:null,
      Duration:'',
      rtoValue:null,
      vehicleSearchFilter: "",
      defaultTeam:{rtoNumber:"All",id:""},
    };
  },
  props:["field","showAllRec","isSummeryReportExist","isAdvanced"],
  methods: {
    onChange() {
        let t = this
      if(!(t.StartTime&&t.EndTime && t.Duration )){
         console.log("#DateTime",t.StartTime,t.EndTime,t.Duration)

        notifyWarn("Please select all the filters");
        return
      }

      this.$emit("update", {
        StartTime: formatISO(this.StartTime),
        EndTime: formatISO(this.EndTime),
        RTONumber:this.rtoValue ?this.rtoValue:'',
        Duration:this.Duration?convertMinutes(this.Duration).toString():this.Duration,
        TenantId:this.getTenantId,
        _query: {
          StartTime: formatISO(this.StartTime),
        EndTime: formatISO(this.EndTime),
        RTONumber:this.rtoValue ?this.rtoValue:'',
         Duration:this.Duration?convertMinutes(this.Duration).toString():this.Duration,
        TenantId:this.getTenantId,
        
        },
      });

    },
         changeVehicle(e){
      if(this.isAdvanced)
     { if(e.value.rtoNumber =='All'){
       this.rtoValue =this.allVehicle
      }
      else
        this.rtoValue = [e.value.rtoNumber]
     
    }
    else {
      { if(e.value.rtoNumber =='All'){
       this.rtoValue =""
      }
      else
        this.rtoValue = e.value.rtoNumber
     
    }
    }
    },
     filterChange(e) {
      this.vehicleSearchFilter = e.filter.value ? e.filter.value.toLowerCase() : "";
    },

  },
   watch: {
    Duration(newVal,oldVal){
      if(newVal < 0){
        this.Duration= oldVal;
      }
    }
  },
    computed: {
   ...mapGetters([ "getVehicles","getTenantId",]),
    getFilteredVehicles() {
      return this.getVehicles.filter((v) => v.rtoNumber.toLowerCase().includes(this.vehicleSearchFilter))
    },
     allVehicle(){
      
    return this.getVehicles.map(v=>{
       return v.rtoNumber
    })  
    }
    },
     created(){
     if(this.isAdvanced){
       this.rtoValue =this.allVehicle
     }
     else
     this.rtoValue=""
    }
};
</script>

<style>
</style>